// extracted by mini-css-extract-plugin
module.exports = {"component":"category_component_1u0zh"};